








import { Component,Prop, Vue } from 'vue-property-decorator';
import '@/styles/MCQ.scss';
import {GeneralService} from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import store from '../store';


@Component({
components: {
}
})

export default class BreadCrumb extends Vue {
private service = new GeneralService();
private entities: GActivity[] = [];
private level_id;
private loaded = false;
private admissionformid:any;
private classid:any;
@Prop({ default: () => [] }) private items!: Array<{ text: string, link: string, active: boolean }>;
private breadcrumbItems = [
{ text: 'eLearning', link: '#', active: true },
{ text: 'Video Learning Subject Select', link: '#' },
{ text: 'Video Learning', link: '#' },
{ text: 'Subject', link: '#' }
];

}

